<template>
    <div class="add-qwilr-definition">
      <h3>Add Definition</h3>
      <div class="form-group mb-4">
        <label for="definition-key" class="form-label">Definition Key</label>
        <input
          type="text"
          id="definition-key"
          class="form-control"
          placeholder="Enter definition key"
          v-model="definitionKey"
      />
      </div>
      <div class="form-group mb-4">
        <label for="definition-name" class="form-label">Definition Name</label>
        <input
          type="text"
          id="definition-name"
          class="form-control"
          placeholder="Enter definition name"
          v-model="definitionName"
      />
      </div>
      <div class="form-group mb-4">
        <label for="description" class="form-label">Description</label>
        <textarea
          id="description"
          class="form-control"
          v-model="description"
          placeholder="Enter description"
          rows="4"
        ></textarea>
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="addDefinition" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Add Definition
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { AddQwilrDefinition } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'

  export default{
    name:"AddQwilrDefinition",
    data(){
        return{
            definitionKey:'',
            definitionName:'',
            description:'',
            isBusy:false
        }
    },
    methods:{
        async addDefinition(){
            this.isBusy=true;
            setTimeout(async () => {
              if (!this.validateFields()){
                this.isBusy=false;
                return;
              } 

            const toast = useToast();
            const payload = 
            { 
              qwilrDefinitionKey:this.definitionKey, 
              qwilrDefinitionName:this.definitionName, 
              description:this.description
            };
        
            await AddQwilrDefinition(payload)
                    .then(response => {
                    if (response.status === 200) {
                        toast.success('Definition added successfully!', {
                        timeout: 2000
                        })
                        this.isBusy=false;
                        this.$emit('definitionAdded'); // Emit the event to notify the parent component
                        this.$emit('close'); // Close the lightbox after adding data stream
                    }
                    })
                    .catch(ex => {
                        this.isBusy=false;
                        const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                        console.log(ex);
                        toast.error(`Failed to add definition : ${errorMessage}`, {timeout: 2000,});
                    })
            },500);
        },
        validateFields() {
          const toast = useToast();

          if (this.definitionKey.trim() === '') {
            toast.error('Definition key is required!', { timeout: 3000 });
            return false; 
          }

          if (this.definitionName.trim() === '') {
            toast.error('Definition name is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    }
  }
 </script>
  
  <style scoped>
  .add-qwilr-definition {
    width: 600px;
    height: 500px;
    padding: 40px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  